import { TextField } from '@mui/material';
import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';

function ModalMessage(props) {
    const [messageText, setMessageText] = useState("");

    const {
        questionModalMessageString,
        questionModalMTextString,
        saveString,
    } = useTranslationHook();

    function hide(){
        props.onHide();
        getToast({ status: 'success', title: 'Mensaje creado exitosamente en el cuestionario.' });
        props.getQuestionsData(props.selectedSection);
        props.getDirectoryData();
    }

    function createMessage(event){
        event.preventDefault();
        customAxios.post(`${GlobalVariables.getURL()}createMessageQuestion/${props.selectedSection}`, {
            message: messageText,
            questionnaire_id: props.selectedQuestionnaire,
            num_columns: 1,
        }, {
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        })
        .then((response) => {
            console.log(response.data)
            hide();
        }, (error) => {
            console.log(error);
            getToast({ status: 'error', title: 'Error al crear mensaje. Vuelve a intentarlo.' });
        });
    }

    return (
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {questionModalMessageString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form id='add-message-form' onSubmit={createMessage}>
                    <div className="row">
                        <div className="col-md-12">
                            <TextField
                                sx={{ width: "100%" }}
                                label={questionModalMTextString}
                                type="text"
                                multiline
                                rows={3}
                                value={messageText} onChange={(e) => setMessageText(e.target.value)}
                                required
                            />
                        </div>
                    </div>                    
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button form='add-message-form' type='submit' className='save-modal-button'>{saveString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalMessage;